import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { withRouter } from 'react-router';
import { components } from 'react-select';

import fixQueryString from 'rebook/apps/utils/urls/fixQueryString';
import popQueryString from 'rebook/apps/utils/urls/popQueryString';
import { FILTER_BY_TYPE } from 'rebook/apps/base/constants';
import Select from 'rebook/apps/base/components/Select';

import styles from './style.scss';


class FilterBookType extends React.Component {
  onChange(bookType) {
    if (bookType.value !== null) {
      let newQueryString = fixQueryString(
        get(this, 'props.location.search', ''), { t: bookType.value }
      );
      newQueryString = popQueryString(newQueryString, ['page']);
      this.props.history.push({
        search: newQueryString,
      });
    }
    else {
      this.props.history.push({
        search: popQueryString(get(this, 'props.location.search', ''), ['t', 'page']),
      });
    }
    this.props.onChange(bookType.value);
  }

  subscriptionOption(props) {
    return (
      <components.Option {...props}>
        <div className={styles.optionTextContainer}>
          <span>{props.children}</span>
        </div>
      </components.Option>
    );
  }

  subscriptionValueContainer(props) {
    return (
      <div className={styles.valueTextContainer}>
        <components.ValueContainer {...props} />
      </div>
    );
  }

  render() {
    const value = FILTER_BY_TYPE.find((item) => (item.value === this.props.bookType));
    return (
      <Select
        name="bookType"
        options={FILTER_BY_TYPE}
        value={value}
        width={this.props.width}
        onChange={(value) => this.onChange(value)}
        isDisabled={this.props.isDisabled}
        components={{
          Option: this.subscriptionOption,
          ValueContainer: this.subscriptionValueContainer,
        }} />
    );
  }
}

FilterBookType.propTypes = {
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  width: PropTypes.number,
  bookType: PropTypes.oneOf([null, 'text', 'audio']),
};

FilterBookType.defaultProps = {
  isDisabled: false,
  width: 200,
  bookType: null,
  onChange: function() {},
};

export default withRouter(FilterBookType);
